import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Button, InlineAlert } from '@chillout/ui'
import { PAIRING_CODE_LENGTH } from '@chillout/core'
import { Card } from '../../shared/Card'
import { CodeEntryDisplay } from '../shared/CodeEntryDisplay'
import { Numpad } from '../shared/numpad'

interface PairingCodeContentProps {
  digits: string[]
  canConfirm: boolean
  isLoading?: boolean
  error?: string | null
  onDigit: (digit: string) => void
  onDelete: () => void
  onConfirm: () => void
  onSwitchToScan: () => void
}

export function PairingCodeContent({
  digits,
  canConfirm,
  isLoading = false,
  error,
  onDigit,
  onDelete,
  onConfirm,
  onSwitchToScan,
}: PairingCodeContentProps) {
  const { t } = useTranslation()

  return (
    <View className="flex-1 items-center justify-center">
      <Card className="w-full px-8 py-10">
        <Text className="mb-8 text-center text-base lg:text-lg text-secondary">
          {t('cashierPairing.codeScreenSubtitle')}
        </Text>
        <CodeEntryDisplay
          digits={digits}
          length={PAIRING_CODE_LENGTH}
          groupAt={3}
          accessibilityLabel={t('cashierPairing.codeProgressAccessibilityLabel', {
            entered: digits.length,
            total: PAIRING_CODE_LENGTH,
          })}
        />
        {error ? (
          <View className="mt-4">
            <InlineAlert message={error} />
          </View>
        ) : null}
        <View className="mt-8">
          <Numpad
            onDigit={onDigit}
            onDelete={onDelete}
            onConfirm={onConfirm}
            canConfirm={canConfirm}
            isLoading={isLoading}
          />
        </View>
        <Button
          label={t('cashierPairing.scanQRInstead')}
          onPress={onSwitchToScan}
          variant="ghost"
          fullWidth={false}
          disabled={isLoading}
          className="mt-2"
        />
      </Card>
    </View>
  )
}
